import useWebData from "../hooks/useWebData";

export const HomeInfoSection = () => {
    const { webData }: any = useWebData();

    return (
        <div className="space-y-20 my-4">
            <section className="max-w-6xl mx-auto px-4 text-center">
                <div className="rounded-2xl bg-gray-100 p-6 max-w-4xl mx-auto mb-8">
                    <div className="flex flex-col md:flex-row items-center justify-center gap-4 text-center md:text-left">
                        <span
                            className="material-symbols-outlined text-[36px]"
                            style={{ color: webData?.websiteHeaderColor }}
                        >
                            airport_shuttle
                        </span>

                        <p className="text-sm text-gray-700">
                            <span className="font-semibold">Airport Shuttle:</span>{" "}
                            Convenient, on-time van transportation to and from
                            <span className="font-medium"> Hobby Airport</span> and
                            <span className="font-medium"> IAH Airport</span>, ideal for
                            families, corporate teams, and group travel.
                        </p>
                    </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                    <div className="rounded-2xl shadow-md p-6">
                        <span className="material-symbols-outlined text-[30px]"
                            style={{
                                color: webData?.websiteHeaderColor
                            }}
                        >
                            no_crash
                        </span>
                        <h3 className="text-lg font-bold mb-2"
                            style={{
                                color: webData?.websiteHeaderColor
                            }}
                        >Choose a Vehicle</h3>
                        <p className="text-sm">Browse our wide range of vehicles that suit every need and budget.</p>
                    </div>
                    <div className="rounded-2xl shadow-md p-6">
                        <span className="material-symbols-outlined text-[30px]"
                            style={{
                                color: webData?.websiteHeaderColor
                            }}
                        >
                            offline_pin
                        </span>
                        <h3 className="text-lg font-bold mb-2"
                            style={{
                                color: webData?.websiteHeaderColor
                            }}
                        >Book Instantly</h3>
                        <p className="text-sm">Reserve your vehicle online with flexible pickup & return options.</p>
                    </div>
                    <div className="rounded-2xl shadow-md p-6">
                        <span className="material-symbols-outlined text-[30px]"
                            style={{
                                color: webData?.websiteHeaderColor
                            }}
                        >
                            airport_shuttle
                        </span>
                        <h3 className="text-lg font-bold mb-2"
                            style={{
                                color: webData?.websiteHeaderColor
                            }}
                        >Drive & Explore</h3>
                        <p className="text-sm">Pick up your ride and hit the road with ease and confidence.</p>
                    </div>
                </div>

            </section>

            {/* Our Services & Coverage */}
            <section className="max-w-6xl mx-auto px-4 text-center">
                <h2 className="text-2xl font-semibold mb-6">
                    JJ Van Rental & Transportation Services
                </h2>

                <p className="text-sm max-w-4xl mx-auto mb-10 text-gray-600">
                    Reliable & affordable passenger and cargo van rentals designed for
                    families, businesses, events, and corporate travel across Houston and
                    surrounding Texas cities.
                </p>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                    {/* Passenger Vans */}
                    <div className="rounded-2xl shadow-md p-6">
                        <span
                            className="material-symbols-outlined text-[32px]"
                            style={{ color: webData?.websiteHeaderColor }}
                        >
                            groups
                        </span>
                        <h3
                            className="font-bold mt-2 mb-2"
                            style={{ color: webData?.websiteHeaderColor }}
                        >
                            Passenger Van Rentals
                        </h3>
                        <p className="text-sm">
                            Rides for families, corporate teams, group travel, weddings,
                            events, and airport transfers with spacious 12 & 15-passenger vans.
                        </p>
                    </div>

                    {/* Cargo Vans */}
                    <div className="rounded-2xl shadow-md p-6">
                        <span
                            className="material-symbols-outlined text-[32px]"
                            style={{ color: webData?.websiteHeaderColor }}
                        >
                            local_shipping
                        </span>
                        <h3
                            className="font-bold mt-2 mb-2"
                            style={{ color: webData?.websiteHeaderColor }}
                        >
                            Cargo & Moving Vans
                        </h3>
                        <p className="text-sm">
                            Perfect for moving, deliveries, equipment hauling, and commercial
                            logistics with heavy-duty cargo vans.
                        </p>
                    </div>

                    {/* Business & Fleet */}
                    <div className="rounded-2xl shadow-md p-6">
                        <span
                            className="material-symbols-outlined text-[32px]"
                            style={{ color: webData?.websiteHeaderColor }}
                        >
                            business_center
                        </span>
                        <h3
                            className="font-bold mt-2 mb-2"
                            style={{ color: webData?.websiteHeaderColor }}
                        >
                            Commercial & Fleet Solutions
                        </h3>
                        <p className="text-sm">
                            Flexible daily, weekly, and monthly rental plans with affordable
                            pricing and unlimited mileage options.
                        </p>
                    </div>
                </div>
            </section>

            {/* Service Areas & Airport Transfers */}
            <section className="mt-16 max-w-6xl mx-auto px-4">
                <div className="rounded-3xl shadow-md p-8 md:p-12 bg-white text-center">
                    {/* Heading */}
                    <h3 className="text-2xl font-semibold mb-4">
                        Serving Houston & Surrounding Cities
                    </h3>

                    <p className="text-sm text-gray-600 max-w-4xl mx-auto mb-8">
                        JJ Van Rental proudly provides reliable passenger and cargo van
                        services across Houston and nearby Texas cities, ensuring convenient
                        pickup and drop-off wherever you need.
                    </p>

                    {/* Cities Grid */}
                    <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3 text-sm text-gray-700 mb-10">
                        {[
                            "Houston",
                            "Missouri City",
                            "Sugar Land",
                            "Stafford",
                            "Hobby",
                            "Tomball",
                            "The Woodlands",
                            "Friendswood",
                            "Richmond",
                            "Conroe",
                            "Cypress",
                            "Katy",
                            "League City",
                            "Kemah",
                            "Baytown",
                            "Pasadena",
                            "Channelview",
                            "Spring",
                        ].map((city) => (
                            <div
                                key={city}
                                className="flex items-center justify-center gap-2 rounded-xl border px-3 py-2 bg-gray-50"
                            >
                                <span
                                    className="material-symbols-outlined text-[18px]"
                                    style={{ color: webData?.websiteHeaderColor }}
                                >
                                    location_on
                                </span>
                                <span>{city}</span>
                            </div>
                        ))}
                    </div>


                </div>
            </section>


            {/* Why Choose Us */}
            <section className="max-w-6xl mx-auto px-4 text-center">
                <h2 className="text-2xl font-semibold mb-8">Why Choose {webData?.companyName}</h2>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                    <div className="rounded-2xl shadow-md p-6">
                        <span className="material-symbols-outlined text-[30px]"
                            style={{
                                color: webData?.websiteHeaderColor
                            }}
                        >
                            contact_support
                        </span>
                        <h3 className="font-bold mb-2"
                            style={{
                                color: webData?.websiteHeaderColor
                            }}
                        >24/7 Support</h3>
                        <p className="text-sm">We're always here to help you on and off the road.</p>
                    </div>
                    <div className="rounded-2xl shadow-md p-6">
                        <span className="material-symbols-outlined text-[30px]"
                            style={{
                                color: webData?.websiteHeaderColor
                            }}
                        >
                            price_check
                        </span>
                        <h4 className="font-bold mb-2"
                            style={{
                                color: webData?.websiteHeaderColor
                            }}
                        >No Hidden Fees</h4>
                        <p className="text-sm">Transparent pricing. What you see is what you pay.</p>
                    </div>
                    <div className="rounded-2xl shadow-md p-6">
                        <span className="material-symbols-outlined text-[30px]"
                            style={{
                                color: webData?.websiteHeaderColor
                            }}
                        >
                            garage_check
                        </span>
                        <h4 className="font-bold mb-2"
                            style={{
                                color: webData?.websiteHeaderColor
                            }}
                        >Well-Maintained Fleet</h4>
                        <p className="text-sm">Every vehicle is thoroughly inspected before every ride.</p>
                    </div>
                </div>
            </section>
        </div>
    )
}